// extracted by mini-css-extract-plugin
export var wrapper = "Header-module--wrapper--7g-D7";
export var container = "Header-module--container--SPZ3P";
export var logo = "Header-module--logo--2EZVS";
export var menuToggle = "Header-module--menuToggle--3eCme";
export var nav = "Header-module--nav--2Vqsn";
export var toggled = "Header-module--toggled--1y-Sf";
export var links = "Header-module--links--3HRY_";
export var languageToggle = "Header-module--languageToggle--3s7wL";
export var activeLanguage = "Header-module--activeLanguage--3CCoq";